<template>
  <div>
    <b-form
      class="w-100 partners-creating__form-container mt-3"
      novalidate
      ref="registerForm"
      @submit.prevent="createPartner"
      id="registerForm"
      :validated="formValidated"
    >
      <b-row>
        <b-col
          cols="12"
          :md="item.type !== 'select' ? 6 : 12"
          v-for="(item, index) in inputs"
          :key="index"
        >
          <h5>{{ item.label }}</h5>
          <b-input-group class="position-relative mb-4" v-if="item.type === 'email'">
            <b-form-input
              :name="item.name"
              v-model.trim="paramsMutated[item.name]"
              class="w-100 rounded"
              type="email"
              :placeholder="item.placeholder"
              autocomplete="email"
              :required="item.required"
            />
            <div class="invalid-tooltip">
              {{ $t('errors.error_validation') }}
            </div>
          </b-input-group>

          <b-input-group class="position-relative mb-4" v-if="item.type === 'password'">
            <b-form-input
              :name="item.name"
              v-model="paramsMutated[item.name]"
              class="w-100 rounded"
              :type="item.toggled ? 'text' : 'password'"
              :placeholder="item.placeholder"
              autocomplete="current-password"
              :required="item.required"
            />
            <div class="invalid-tooltip">
              {{ $t('form.required_field') }}
            </div>
            <i
              class="fas position-absolute text-muted input-icon"
              :class="!item.toggled ? 'fa-eye' : ' fa-eye-slash'"
              @click="item.toggled = !item.toggled"
            />
          </b-input-group>
          <b-input-group
            class="position-relative mb-4"
            v-if="item.type === 'text' || item.type === 'url'"
          >
            <b-form-input
              :name="item.name"
              v-model="paramsMutated[item.name]"
              class="w-100 rounded"
              :type="item.type"
              v-mask="item.mask"
              :placeholder="item.placeholder"
              autocomplete="current-password"
              :required="item.required"
              @input="onInput($event, item)"
            />
            <div class="invalid-tooltip">
              {{ $t('form.required_field') }}
            </div>
          </b-input-group>
          <b-input-group class="position-relative mb-4" v-if="item.type === 'select'">
            <multiselect
              v-model="paramsMutated[item.name]"
              class="w-100"
              :label="item.trackBy"
              :track-by="item.trackBy"
              :preselect-first="true"
              :placeholder="item.placeholder"
              :options="item.options"
              :searchable="false"
              :allow-empty="!item.required"
              :close-on-select="true"
              deselect-label=""
              selected-label
              select-label
            >
              <template slot="noResult">
                {{ $t('global.no_results') }}
              </template>
            </multiselect>
          </b-input-group>
        </b-col>
      </b-row>

      <div
        id="recaptcha"
        class="g-recaptcha"
        :data-sitekey="recaptchaPublicKey"
        data-callback="onRecaptchaSubmit"
        data-size="invisible"
      />

      <div class="d-flex justify-content-center">
        <b-button class="w-50 align-content-center font-weight-bold p-2 mt-2" type="submit">
          {{ $t('login.register') }}
        </b-button>
      </div>
    </b-form>
  </div>
</template>

<script>
import i18n from '../../utils/i18n';
import axios from '../../utils/axios';
import ReCaptcha from '../../mixins/recaptcha';

export default {
  name: 'PublicPartnersRegistrationView',
  data() {
    return {
      formValidated: false,
      paramsMutated: {},
      debounceCreate: () => {},
    };
  },

  mixins: [ReCaptcha],

  props: {
    inputs: {
      type: Array,
    },
  },

  mounted() {
    this.getPricingOptions();
    this.initRecaptcha(this.submitPartnerData);
  },
  methods: {
    async getPricingOptions() {
      await axios
        .get('/pricing/plans')
        .then(({ data }) => {
          this.inputs.map((item) => {
            if (item.label === i18n.t('login.wallkit_pricing_plan')) {
              item.options = data.items;
              this.$set(this.paramsMutated, item.name, data.items[0]);
            }
          });
        })
        .catch((error) => {
          console.log('get pricing plans error', error);
        });
    },
    async submitPartnerData(token) {
      await axios
        .post('/partners/invite/create', {
          ...this.paramsMutated,
          recaptcha_token: token,
          pricing_plans_id: this.paramsMutated.pricing_plan.id,
        })
        .then(() => {
          this.$noty.success(this.$t('login.confirmation_link_was_sent'));
          this.$router.push('/login');
        })
        .catch((error) => {
          console.log('create partner error', error);
          this.$noty.error(error.response.data.error_description);
          this.resetRecaptcha();
        });
    },
    async createPartner() {
      this.formValidated = true;

      if (this.$refs.registerForm && this.$refs.registerForm.checkValidity()) {
        this.submitRecaptcha();
      }
    },
    onInput(value, input) {
      let targetValue = event.target.value;
      if (input.type === 'url') {
        if (
          !targetValue.substring(0, 8).includes('https://') &&
          !targetValue.substring(0, 7).includes('http://')
        ) {
          if (
            targetValue.includes('ttps://') ||
            targetValue.includes('htps://') ||
            targetValue.includes('htts://') ||
            targetValue.includes('https//') ||
            targetValue.includes('https:/') ||
            targetValue.substring(0, 7).includes('ttp://') ||
            targetValue.substring(0, 7).includes('htp://') ||
            targetValue.substring(0, 7).includes('htt://') ||
            targetValue.substring(0, 7).includes('http//') ||
            targetValue.substring(0, 7).includes('http:/') ||
            targetValue.substring(0, 7).includes('http:')
          ) {
            this.$set(this.paramsMutated, input.name, '');
            return;
          }
          let formattedValue = 'https://' + targetValue;
          this.$set(this.paramsMutated, input.name, formattedValue);
        }
      }
    },
  },
};
</script>
